module.exports = __webpack_public_path__ + "img/moishop_portfolio_5_2x.0531bca9.png";